import { IHinhThucThanhToan } from "../../../model/respone/category/IHinhThucThanhToan"
import { generateActionTypeIds } from "../generateActionTypeIds"
import IGenericActionType from "../IGenericActionType"

export const eHinhThucThanhToanActionTypeDefine = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IHinhThucThanhToan[],
    LOAD_ERROR: "",

    SHOW_EDIT_MODAL: {} as undefined | IHinhThucThanhToan,
    CLOSE_EDIT_MODAL: undefined,
    
    SAVE_START: {} as IHinhThucThanhToan,
    SAVE_SUCCESS: {} as IHinhThucThanhToan,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",


}
export const eHinhThucThanhToanActionTypeIds = generateActionTypeIds(eHinhThucThanhToanActionTypeDefine, "HINH_THUC_THANH_TOAN")

export type IHinhThucThanhToanActions = IGenericActionType<typeof eHinhThucThanhToanActionTypeDefine, "HINH_THUC_THANH_TOAN">